export interface CurrencyType {
  code: string;
  name: string;
}

export const currencies: readonly CurrencyType[] = [
  { code: 'Eur', name: 'Euro' },
  { code: 'Gbp', name: 'Great Britain pound' }
];
